<template>
  <div class="c-material-lifecycle">
    <div class="material-info-row" :class="loading && 'loading'">
      <span>
        素材ID：
        <span class="text">{{ queryForm.id }}</span>
      </span>
      <span>
        素材名称：
        <span class="text">{{ name }}</span>
      </span>
      <span>
        设计者：
        <span class="text">{{ author }}</span>
      </span>
      <span>
        上传时间：
        <span class="text">{{ creatime }}</span>
      </span>

      <span>
        起投时间：
        <span class="text">{{ begintime }}</span>
      </span>

      <span>
        最后投放时间：
        <span class="text">{{ endtime }}</span>
      </span>
    </div>
    <div class="query-form">
      <ElForm inline label-width="60px" @submit.native.prevent class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="媒体" label-width="40px">
          <el-select
            v-model="queryForm.mediaIds"
            multiple
            collapse-tags
            filterable
            clearable
            @change="queryAction"
            style="width: 160px"
            placeholder="全部"
          >
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="平台" label-width="40px">
          <el-select
            v-model="queryForm.platforms"
            multiple
            collapse-tags
            filterable
            clearable
            @change="queryAction"
            style="width: 140px"
            placeholder="全部"
          >
            <el-option v-for="item in platformData2" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="统计时间" label-width="70px">
          <DateRangePicker v-model="queryForm.datetime" :clearable="false" @change="handleDatetime" style="width: 220px"></DateRangePicker>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <el-button @click="modalColumn = true">自定义列</el-button>
          <el-button @click="downData" style="margin-left: 2px" :loading="exportLoading">数据导出</el-button>
        </ElFormItem>
      </ElForm>
    </div>
    <div class="c-m-table">
      <div class="c-compare-wrap">
        <div class="c-compare-form">
          <Select v-model="referEc" style="width: 180px">
            <Option v-for="drop in referEcDrop" :key="drop.key" :value="drop.key">{{ drop.title }}</Option>
          </Select>
          <span class="compare-checkbox"> <Checkbox v-model="isRefer" @on-change="changeRefer" style="margin: 0 8px">对比</Checkbox></span>

          <Select v-if="isRefer" v-model="compareEc" style="width: 180px">
            <Option v-for="drop in compareEcDrop" :key="drop.key" :value="drop.key">{{ drop.title }}</Option>
          </Select>
        </div>
        <div class="c-echarts">
          <compare-echart :loading="loading" :compare-options="echartsOptions" />
        </div>
      </div>
      <Viewport v-model="tableHeight">
        <lifecycle-table
          :height="tableHeight"
          :loading="loading"
          :data="tableList"
          :columns="tableCol"
          :summary="summaries"
          @sort-change="sortTable"
        />
        <Page
          show-total
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="10"
          @on-change="changePIndex"
        />
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      v-model="modalColumn"
      name="MaterLifeCustomColumn"
      :data="rawTableCols"
      :sub-title="['报表数据', '创角留存', '创角LTV', '视频数据']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script>
import moment from 'moment'
import { REPORT_MATERIAL_ANALYSIS_DATE } from '@/views/download-center/data/const.js'
import { mul } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { toThousands, toPercentFixed, datetimeToDay } from '@/common/js/filters'
import { transferTaskQueryConditions } from '@/views/download-center/data/utils.js'

import mixinTable from './mixin_table'
import columns from '../data/material_record_life_column'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import CustomColumn from '@/components/converter/custom-column2.vue'
import CompareEchart from '@/components/echarts/echart.vue'
import theme from '@/components/echarts/theme'
import LifecycleTable from './components/lifecycle-table.vue'
import { getMaterialAnalysisDailyData, initDownloadCenterTask } from '@/api/report.model'

import { platformData2 } from '../data/platformData'
import { initPageData, MEDIAS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([MEDIAS])

export default {
  name: 'labelAnalysisLifeCycle',
  mixins: [mixinTable],
  components: { CustomColumn, LifecycleTable, DateRangePicker, CompareEchart },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    tableCol() {
      return this.tableColumns.filter((ret) => ret.checked)
    },
    referEcDrop() {
      return this.dropData.filter((ret) => ret.key !== this.compareEc)
    },
    compareEcDrop() {
      return this.dropData.filter((ret) => ret.key !== this.referEc)
    }
  },
  methods: {
    queryAction() {
      this.pageIndex = 1
      this.getData()
    },
    getData() {
      const [beginTime, endTime] = this.queryForm.datetime || []

      const param = {
        platforms: this.queryForm.platforms,
        mediaIds: this.queryForm.mediaIds,
        [this.dimImageDetail === '1' ? 'imageDetailId' : 'imageId']: this.queryForm.id,
        beginTime,
        endTime,
        sort: this.sort,
        order: this.order
      }
      if (this.loading) return
      this.loading = true
      getMaterialAnalysisDailyData(param)
        .then((data) => {
          if (!data) return
          const { imageInfo, list, sumData } = data
          // 素材基本信息
          if (imageInfo) {
            const { imageName, designerName, uploadTime, adStartTime, adEndTime } = imageInfo
            this.name = imageName
            this.author = designerName
            this.creatime = typeof uploadTime === 'number' ? datetimeToDay(uploadTime) : uploadTime
            this.begintime = typeof adStartTime === 'number' ? datetimeToDay(adStartTime) : adStartTime
            this.endtime = typeof adEndTime === 'number' ? datetimeToDay(adEndTime) : adEndTime
          }
          if (isArray(list) && sumData) {
            this.sumData = sumData
            this.listData = list
            this.tableList = this.calcTableData()
            this.total = list.length
            this.creatEchart(this.referEc, this.compareEc)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    calcTableData() {
      const start = (this.pageIndex - 1) * 10
      const end = 10 * this.pageIndex
      return this.listData.slice(start, end)
    },
    creatEchart(refer, compare) {
      const ecKeys = this.isRefer ? [refer, compare] : [refer]
      const tableList = JSON.parse(JSON.stringify(this.listData))
      const xAxisData = tableList.sort((a, b) => a.tdate - b.tdate).map((ret) => datetimeToDay(ret.tdate))
      const referData = tableList
        .sort((a, b) => a.tdate - b.tdate)
        .map((ret) => (refer.includes('Rate') || refer.includes('createRole24hRoi') ? mul(100, ret[refer]) : ret[refer]))
      const compareData = tableList
        .sort((a, b) => a.tdate - b.tdate)
        .map((ret) => (compare.includes('Rate') || compare.includes('createRole24hRoi') ? mul(100, ret[compare]) : ret[compare]))
      const legends = ecKeys.map((ret) => {
        const column = columns.filter((t) => t.key === ret).pop()
        return column.title
      })
      const yAxis = ecKeys.map((ret, i) => {
        const column = columns.filter((t) => t.key === ret).pop()
        let unit = ''
        if (ret.includes('Rate') || ret === 'createRole24hRoi') unit = '%'
        else if (['paperUseAmount', 'amount', 'activeCost', 'createRoleCost', 'sumRecharge', 'sumMoney'].includes(ret)) unit = '元'
        return {
          name: column.title,
          nameGap: 5,
          type: 'value',
          axisLabel: {
            formatter: `{value} ${unit}`
          }
        }
      })
      const series = ecKeys.map((ret, i) => {
        const column = columns.filter((t) => t.key === ret).pop()
        return {
          name: column.title,
          data: i ? compareData : referData,
          type: 'line',
          yAxisIndex: i
        }
      })
      const tooltips = ecKeys.map((ret, i) => {
        let unit = ''
        if (ret.includes('Rate') || ret === 'createRole24hRoi') unit = '%'
        else if (['paperUseAmount', 'amount', 'activeCost', 'createRoleCost', 'sumRecharge', 'sumMoney'].includes(ret)) unit = '元'
        return `<dd class="tooltop-span"><span style="background-color: ${theme.color[i]}"></span>{a${i}}: {c${i}} ${unit}</dd>`
      })
      let formatHtml = '<h3 class="tooltip-h3">{b0}</h3>'
      formatHtml += tooltips.join('')
      // 图表配置
      this.echartsOptions = {
        legend: {
          bottom: 0,
          itemGap: 20,
          itemWidth: 12,
          itemHeight: 6,
          align: 'right',
          data: legends
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          padding: 10,
          formatter: formatHtml
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: !0,
            position: 'bottom',
            offset: 0,
            data: xAxisData
          }
        ],
        yAxis,
        series,
        grid: { top: 35, left: 16, right: 16, bottom: 34, containLabel: !0 }
      }
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumData))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const numbers = [
          'pv',
          'clickNum',
          'paperUseAmount',
          'amount',
          'newRoleMoney',
          'sumRecharge',
          'sumMoney',
          'downNum',
          'newUserNum',
          'createRoleNum',
          'newRoleNum',
          'payRoleUserNum',
          'timeDiff'
        ]
        // 格式化数据格式
        if (numbers.includes(prop)) sums[index] = toThousands(data[prop])
        else if (prop?.indexOf('Rate') > -1) sums[index] = toPercentFixed(data[prop])
        else if (['createRole24hRoi', 'createRoleRoi1d', 'createRoleRoi3d', 'createRoleRoi7d'].includes(prop)) {
          sums[index] = toPercentFixed(data[prop])
        } else sums[index] = data[prop]
      })
      return sums
    },
    handleDatetime(dates) {
      const [start, end] = dates
      const limitDate = moment(end).subtract(90, 'days')

      if (limitDate.isAfter(start)) {
        this.$Message.warning('日期范围不能超过90天！')
        const newDate = limitDate.format('YYYY-MM-DD')
        this.datetime = [newDate, end]
      }

      this.pageIndex = 1
      this.getData()
    },
    changePIndex(index) {
      this.pageIndex = index
      this.tableList = this.calcTableData()
    },
    changeRefer(val) {
      this.isRefer = val
      !val && (this.compareEc = 'paperUseAmount')
      this.creatEchart(this.referEc, this.compareEc)
    },

    downData() {
      const [beginTime, endTime] = this.queryForm.datetime || []
      const exportColumnOrderMap = {}
      this.tableColumns.forEach((col) => {
        if (col.checked && !col.exclude_export) exportColumnOrderMap[col.key] = col.title
      })

      const params = {
        sessionid: this.$store.state.token,
        platforms: this.queryForm.platforms,
        mediaIds: this.queryForm.mediaIds,
        [this.dimImageDetail === '1' ? 'imageDetailId' : 'imageId']: this.queryForm.id,
        exportColumnOrderMap
      }

      if (beginTime && endTime) {
        params.beginTime = beginTime
        params.endTime = endTime
      }

      this.order && (params.order = this.order)
      this.sort && (params.sort = this.sort)

      const conditionText = transferTaskQueryConditions.call(
        this,
        {
          ...params,
          [this.dimImageDetail === '1' ? 'imageDetailId' : 'imageId']: this.queryForm.id,
          name: this.name,
          author: this.author,
          createtime: this.creatime,
          begintime: this.begintime,
          endtime: this.endtime
        },
        REPORT_MATERIAL_ANALYSIS_DATE
      )

      this.exportLoading = true
      initDownloadCenterTask({
        pageType: REPORT_MATERIAL_ANALYSIS_DATE,
        queryCondition: { ...params, conditionText }
      }).then((data) => {
        this.exportLoading = false
        if (data.msg) {
          this.$Message.success(data.msg)
          this.$store.commit('setDownloadBadgeActive', 1)
        }
      })
    },
    proLoadData() {
      // 切换到其他路由也会触发，判断是否当前路由名称；
      if (this.$route.name !== 'materialAnalysisLifeCycle') return
      const prevId = this.queryForm.id

      const { mediaIds, id, platforms, beginTime, endTime, dimImageDetail } = this.$route.query
      const [oldBeginTime, oldEndTime] = this.queryForm.datetime

      this.dimImageDetail = dimImageDetail || null
      this.queryForm.mediaIds = mediaIds ? mediaIds.split(',').map(Number) : []
      this.queryForm.id = id
      this.queryForm.platforms = platforms ? platforms.split(',').map(Number) : []
      this.queryForm.datetime = [beginTime, endTime]

      // 渲染EC对比下拉框
      this.referEc = 'amount'
      this.compareEc = 'paperUseAmount'

      // 广告数据页面需要keep-alive缓存，但是又可以从素材分析的分日数据页面跳转过来
      // 这里判断如果路由传过来的id和当前的id不一致，那么需要重新请求数据
      // 其他情况不请求
      if (Number(prevId) !== Number(id)) {
        this.queryAction()
      }

      if (beginTime !== oldBeginTime || endTime !== oldEndTime) {
        this.queryAction()
      }
    },
    onTableColsChange(cols) {
      this.modalColumn = false
      this.tableColumns = cols
    },
    headerDragend({ n, o, column }) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    }
  },
  data() {
    return {
      dimImageDetail: null,
      platformData2,
      tableHeight: 330,
      tableColumns: [],
      rawTableCols: columns,
      // id: '',
      // platform: '',
      name: null,
      author: null,
      creatime: null,
      begintime: null,
      endtime: null,
      // mediaId: '',
      // columns: [], // 表格字段
      tableList: [], // 表格数据
      listData: [], // 所有数据
      sumData: [], // 统计数据
      dropData: [], // 对比下拉数据
      isRefer: null, // 是否对比
      referEc: '',
      compareEc: '', // 对比字段
      echartsOptions: {},
      exportLoading: false,

      queryForm: {
        id: '',
        platforms: [],
        mediaIds: [],
        datetime: []
      }
    }
  },
  watch: {
    referEc(nVal) {
      this.creatEchart(nVal, this.compareEc)
    },
    compareEc(nVal) {
      this.creatEchart(this.referEc, nVal)
    }
  },
  activated() {
    this.proLoadData()
  },
  created() {
    const dropData = JSON.parse(JSON.stringify(columns))
    dropData.shift()
    this.dropData = dropData
    this.proLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-material-lifecycle {
  position: relative;
  height: 100%;

  .material-info-row {
    margin-bottom: 2px;
    &.loading {
      filter: blur(3px);
    }
    > span {
      margin-right: 8px;
      .text {
        color: red;
      }
    }
  }

  .query-form {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .c-m-table {
    height: calc(100% - 49px);
    border-top: 1px solid #eee;

    .c-table-list {
      height: 44px;

      .c-pane {
        height: 100%;
      }
    }

    .c-compare-wrap {
      height: 350px;
      margin-bottom: 12px;
      padding: 8px 12px 0;
      background-color: #fff;

      .c-compare-form {
        width: 420px;
        height: 48px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 8px;

        .compare-checkbox {
          width: 70px;
        }
      }

      .c-echarts {
        height: calc(100% - 48px);
      }
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
